var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background-curriculum"},[_c('b-container',[_c('b-row',_vm._l((_vm.levels),function(level){return _c('b-col',{key:level.id,staticClass:"text-left mt-3",attrs:{"cols":"12","md":"4"}},[_c('h4',[_vm._v(_vm._s(level.title))]),_c('p',{domProps:{"innerHTML":_vm._s(level.description)}}),_c('router-link',{attrs:{"to":{
            name: 'curriculumshow',
            params: { id: level.id }
          }}})],1)}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }